import styled from 'styled-components';
import BaseModal from 'components/Modal';

export const Modal = styled(BaseModal)`
  & > :first-child {
    padding: 0;
  }
`;
